import styled from 'styled-components';

export const FaqStyles = styled.div`
  text-align: left;
  margin-bottom: 50px;

  ${props => props.theme.media.md} {
    padding-right: 88px;
    margin-bottom: 150px;
  }

  h1 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 36px;
    line-height: 48px;
    color: #272c38;
    margin-top: 16px;
    margin-bottom: 24px;
    text-align: left;
  }

  .faq-section {
    max-width: 789px;
    width: 100%;
    margin-bottom: 32px;
    padding-bottom: 32px;
    border-bottom: 1px solid rgba(18, 23, 36, 0.2);

    ${props => props.theme.media.md} {
      margin-bottom: 48px;
      padding-bottom: 48px;
    }

    h2 {
      max-width: 640px;
      width: 100%;
      font-family: 'Poppins';
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.01em;
      color: #272c38;
      margin-bottom: 8px;
      text-align: left;

      ${props => props.theme.media.md} {
        font-size: 18px;
        line-height: 28px;
      }
    }

    .description {
      max-width: 640px;
      width: 100%;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #272c38;
      margin-top: 8px;
      margin-bottom: 16px;

      p, li, a {
        font-family: 'Poppins';
      }

      a {
        color: #1776B6;
        text-decoration: underline;
      }

      ${props => props.theme.media.md} {
        font-size: 16px;
        line-height: 24px;
      }
    }

    .btn {
      font-size: 14px;
      line-height: 20px;
    }

    .disclaimer {
      max-width: 640px;
      width: 100%;

      font-family: 'Poppins';
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.01em;

      display: flex;
      align-items: center;
      padding: 6px 16px;
      gap: 12px;
      background: rgba(23, 118, 182, 0.12);
      border-radius: 4px;
      margin-top: 16px;
      margin-bottom: 16px;
      padding: 13px 16px;

      svg {
        width: 20px;
        height: 20px;
        min-width: 20px;
        min-height: 20px;
      }
    }

    > img {
      display: block;
      max-width: 789px;
      width: 100%;
      margin-top: 24px;
    }

    video {
      display: block;
      max-width: 789px;
      width: 100%;
      margin-top: 24px;
    }


    .Collapsible {
      position: relative;
      padding: 14px 16px;
      width: 100%;
      background: #F8F6F4;
      border-radius: 8px;
      margin-bottom: 16px;
      color: #000;

      &:before {
        position: absolute;
        content: '';
        top: 10px;
        right: 10px;
        width: 44px;
        height: 44px;
        background-image: url('/icons/accordion-close.svg');
        pointer-events: none;
      }

      &.active {
        &:before {
          background-image: url('/icons/accordion-open.svg');
        }
      }

      .Collapsible__trigger {
        display: block;
        position: relative;
        width: 100%;
        font-family: 'Poppins';
        font-weight: 400;
        font-size: 24px;
        line-height: 36px;
        letter-spacing: 0.0075em;
      }

      .subtitle {
        font-family: 'Poppins';
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.02em;
        margin-top: 12px;
      }

      .text {
        font-family: 'Poppins';
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.01em;

        b,strong {
          display: block;
          color: rgba(18, 23, 36, 0.65);
          font-family: 'Poppins';
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.01em;
        }

        p {
          margin: 12px 0;
          padding: 0;
        }

        br {
          display: none;
        }
      }
    }

  }
`;